import React from 'react';
import moment from 'moment';

export function DateTimeColumnFormatter(cellContent) {
  return (
    <div className="d-flex justify-content-start flex-column">
      <span className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
       {cellContent ? moment(cellContent).format('DD-MM-YYYY') : ''}
      </span>
      <span className="text-dark-75 d-block font-size-lg text-nowrap">
       {cellContent ? moment(cellContent).format('HH:mm') : ''}
      </span>
    </div>
  );
}
